<template>
  <div class="pressureline" id="pressureline" ref="pressureline"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["needData"],
  mounted() {
    // setTimeout(()=>{
    //   this.pressureline(this.needData);
    // },200)
    // this.pressureline(this.needData);
  },
  watch: {
    needData() {
      this.pressureline(this.needData);
    },
  },
  methods: {
    pressureline(param) {
      let myEchart = this.$echarts.init(
        document.getElementById("pressureline")
      );
      // console.log(param);
      var month = [];
      var minimum = [];
      var standard = [];
      var highest = [];
      param.forEach((item) => {
        month.push(item.month);
        minimum.push(item.minimum);
        standard.push(item.standard);
        highest.push(item.highest);
      });
      let option = {
        color: ["#dba53f", "#59ddfe", "#daf6fd"],
        legend: {
          x: "left",
          top: "0%",
          left: "20%",
          icon: "rect",
          itemWith: "25",
          itemHeight: "2",
          textStyle: {
            color: "#f5f5f6",
            fontSize: 10,
            padding: [0, 8, 0, 8],
          },
        },
        grid: {
          top: "15%",
          left: "8%",
          right: "2%",
          bottom: "23%",
        },
        xAxis: [
          {
            name: "月",
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#5b7486",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#b9bec6",
            },
            splitLine: {
              show: false,
            },
            boundaryGap: false,
            data: month,
          },
        ],

        yAxis: [
          {
            type: "value",
            name: "(PA)",

            nameTextStyle: {
              color: "#b9bec6",
              fontSize: 12,
              padding: [0, 20, 0, 0],
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#5b7486",
                fontSize: 12,
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#587485",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#b9bec6",
              },
            },
          },
        ],
        series: [
          {
            name: "最低",
            type: "line",
            showSymbol: false,
            lineStyle: {
              normal: {
                color: "#dba53f",
              },
            },

            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(219,165,63,0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(219,165,63,0)",
                    },
                  ],
                  false
                ),
              },
            },
            data: minimum, //data.values
          },
          {
            name: "标准",
            type: "line",
            showSymbol: false,

            lineStyle: {
              normal: {
                color: "#59ddfe",
              },
            },

            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(89,221,254,0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(89,221,254,0)",
                    },
                  ],
                  false
                ),
              },
            },
            data: standard, //data.values
          },
          {
            name: "最高",
            type: "line",
            showSymbol: false,

            lineStyle: {
              normal: {
                color: "#daf6fd",
              },
            },

            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(218,246,253,0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(218,246,253,0)",
                    },
                  ],
                  false
                ),
              },
            },
            data: highest, //data.values
          },
        ],
      };

      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.pressureline {
  width: 100%;
  height: 100%;
}
</style>
